





















































import { Component, Vue } from 'vue-property-decorator'
import { OperationItemType } from '../../../types/type'
import { encode, decode } from 'js-base64'
@Component({
  name: 'CapitalShiftToHistoryDetail',
  components: {
    'concise-card-have-title-acquiescent': () => import('../../../components/common/conciseCardHaveTitleAcquiescent.vue'),
    'capital-shift-to-affirm-table': () => import('../../../components/capitalShiftToAffirmTable/index.vue'),
    'loading-container': () => import('../../../components/loading.vue')
  }
})
export default class CapitalShiftToHistoryDetail extends Vue {
  public tableDetail: any = {}
  // 附件预览：
  public dialogVisibleForPreviewFile: boolean = false
  public dialogVisiblePreviewUrl: string = ''
  public dialogVisibleiframeShowFlag: boolean = false
  // 列头操作：
  public operationForButtonOfTableHeader: Array<OperationItemType> = [
    {
      title: "<span class='el-icon-caret-left m_r5'></span>返回",
      key: 'back',
      type: 'primary',
      size: ''
    }
  ]

  get source () {
    return this.$route.query.source
  }

  get tableTitle () {
    let tableTitle = ''
    if (this.source === 'school') {
      tableTitle = '资金转出登记表'
    } else {
      tableTitle = '资金转入确认表'
    }
    return tableTitle
  }

  get tablesubtitle () {
    let tablesubtitle = ''
    if (this.source === 'school') {
      tablesubtitle = '转出登记表'
    } else {
      tablesubtitle = '转入确认表'
    }
    return tablesubtitle
  }

  get tablesubtitle2 () {
    let tablesubtitle2 = ''
    if (this.source === 'school') {
      tablesubtitle2 = '转出'
    } else {
      tablesubtitle2 = '转入'
    }
    return tablesubtitle2
  }

  created () {
    const { detail } = this.$route.query as any
    if (!detail) return this.$router.go(-1)
    const detailInfo = JSON.parse(decode(detail))
    this.tableDetail = detailInfo
    this.$set(this.$route.meta, 'title', `食堂资金管理-资金${this.tablesubtitle}`)
  }

  // 预览：
  previewBtn (v) {
    let _that: any = this
    this.dialogVisibleForPreviewFile = true
    let previewUrl = _that.$previewURL + '/onlinePreview?url=' + encodeURIComponent(encode(v))
    this.dialogVisiblePreviewUrl = previewUrl
  }

  // 预览框打开的时候：
  dialogVisibleOpened () {
    let _that: any = this
    _that.dialogVisibleiframeShowFlag = false
    _that.$nextTick(() => {
      let iframeBox = document.querySelector('#iframeBoxOfdialogVisible')
      if ((iframeBox as any).attachEvent) {
        ;(iframeBox as any).attachEvent('onload', function () {
          _that.dialogVisibleiframeShowFlag = true
        })
      } else {
        ;(iframeBox as any).onload = function () {
          _that.dialogVisibleiframeShowFlag = true
        }
      }
      _that.dialogVisibleiframeShowFlag = true
    })
  }

  // 操作按钮：
  operationForButton ({ key }, row, uploadFile?: File) {
    switch (key) {
      case 'back':
        this.$router.go(-1)
        break
    }
  }
}
